import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom"; // If using React Router
import { userlogout } from "../src/public/Signin/loginSlice";
import { useDispatch } from "react-redux";

const AutoLogout = () => {
  const navigate = useNavigate();
  const logoutTimer = useRef(null);
  const dispatch = useDispatch();

  // Function to log the user out
  const logout = () => {
    if (localStorage.getItem("user")) {
      // alert("Session expired due to inactivity!");
      localStorage.removeItem("user");
      localStorage.clear();
      dispatch(userlogout());
      navigate("/signin");
    } else {
      // alert("already logged out!");
    }

  };

  // Function to reset the inactivity timer
  const resetTimer = () => {
    if (logoutTimer.current) {
      clearTimeout(logoutTimer.current);
    }
    logoutTimer.current = setTimeout(logout, 1200000); // 60 seconds
    // logoutTimer.current = setTimeout(logout, 60000); // 60 seconds
  };

  useEffect(() => {
    // Start the inactivity timer
    resetTimer();

    // Add event listeners for user activity
    window.addEventListener("mousemove", resetTimer);
    window.addEventListener("keydown", resetTimer);
    window.addEventListener("click", resetTimer);
    window.addEventListener("scroll", resetTimer);

    return () => {
      // Cleanup event listeners on unmount
      window.removeEventListener("mousemove", resetTimer);
      window.removeEventListener("keydown", resetTimer);
      window.removeEventListener("click", resetTimer);
      window.removeEventListener("scroll", resetTimer);
      clearTimeout(logoutTimer.current);
    };
  }, []);

  return null; // No UI needed for this component
};

export default AutoLogout;
